export default __webpack_public_path__ + "static/media/01.d3b43909.jpg";